'use client';
import { ELButton } from '@davincihealthcare/elty-design-system-react';
import { useState } from 'react';

export const HomeHeroExpandable: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <>
      <div className={`text-ellipsis text-xl text-neutral-darker [&>p]:mb-2 ${!isExpanded ? 'line-clamp-2' : ''}`}>{children}</div>
      <div>
        <ELButton
          label={isExpanded ? 'Mostra meno' : 'Leggi di più'}
          color="primary"
          variant="text"
          size="small"
          onClick={() => setIsExpanded(!isExpanded)}
        />
      </div>
    </>
  );
};
